import './Needs.css'

const Needs = () =>{
    return (
        <>
        
        <div className="needsbg">
            <div className='container needcontent' >
                <h4 className='needhead' >Why You Need SAP Business One (SAP B1)</h4>
                <p className='needpara'>
                In today’s fast-paced business environment, efficiency, accuracy, and real-time insights are critical for success. SAP Business One (SAP B1) is an all-in-one ERP solution designed to help small and medium-sized businesses streamline operations, reduce errors, and improve decision-making. </p>
            </div>
        </div>
        </>
        );
}

export default Needs